import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./topbar.css";
import dmilogolong from "../../images/DeepMedIQ-long.jpeg";


/* 🔥 Global hook so hamburger can open sidebar */
if (!window.openSidebar) {
  window.openSidebar = { current: null };
}

function Topbar({ showBanner, onCloseBanner, resultsMode }) {
  const { user, isAuthenticated, loginWithRedirect } = useAuth0();

  const initials = isAuthenticated && user?.name
    ? user.name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase()
    : null;

  return (
    <>
      {/* TRUST BANNER */}
      {showBanner && (
        <div className="trust-banner">
          <span className="trust-banner-text">
            DeepMedIQ partners with leading medical societies to deliver guideline-based clinical intelligence
          </span>
          <button className="trust-banner-close" onClick={onCloseBanner}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
      )}

      <header className={`topbar ${showBanner ? 'topbar--with-banner' : ''} ${resultsMode ? 'topbar--results-mode' : ''}`}>

        {/* HAMBURGER — hidden in results mode on desktop (moved to mini sidebar), shown on mobile always */}
        {(!resultsMode || true) && (
          <div className={`topbar-left${resultsMode ? ' topbar-left--results-mobile' : ''}`}>
            <button
              className={`hamburger${resultsMode ? ' hamburger--results-mobile' : ''}`}
              onClick={() => window.openSidebar && window.openSidebar()}
            >
              ☰
            </button>
          </div>
        )}

        {/* LOGO — centered on landing, small corner on results */}
        <a
          href="/landing"
          className="logo-container"
          onClick={(e) => {
            e.preventDefault();
            sessionStorage.removeItem("currentThreadId");
            sessionStorage.removeItem("qaHistory");
            sessionStorage.removeItem("searchHistory");
            window.location.replace('/landing');
          }}
        >
          <img src={dmilogolong} alt="DeepMedIQ" className="dmi-icon" />
        </a>

        {/* RIGHT SLOT — auth buttons (unauthenticated) or avatar (authenticated) */}
        {isAuthenticated ? (
          <div className="topbar-user">
            {user?.picture ? (
              <img src={user.picture} alt={user.name} className="topbar-avatar" />
            ) : (
              <div className="topbar-avatar topbar-avatar--initials">{initials}</div>
            )}
            <span className="topbar-username">{user?.name?.split(" ")[0]}</span>
          </div>
        ) : !resultsMode && (
          <div className="auth-buttons">
            <button
              className="auth-signup-btn"
              onClick={() => loginWithRedirect({ appState: { returnTo: "/" } })}
            >
              Log in
            </button>
            <button
              className="auth-login-btn"
              onClick={() => loginWithRedirect({
                authorizationParams: { screen_hint: "signup" },
                appState: { returnTo: "/" }
              })}
            >
              Sign up
            </button>
          </div>
        )}
      </header>
    </>
  );
}

export default Topbar;
